module.exports = __webpack_public_path__ + "img/img-40d017.png";